export default "__VITE_ASSET__DJLch54e__"